import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-10 justify-content-between" }
const _hoisted_2 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = {
  key: 0,
  class: "card mb-5 mb-xl-8"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "card-label" }, "Search Details")
  ])
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = {
  key: 1,
  class: "card mb-5 mb-xl-8"
}
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = {
  class: "card-title d-flex justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "card-label" }, "Record List", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "me-5" }, "Set Search Time", -1)
const _hoisted_13 = { class: "card-body py-4" }
const _hoisted_14 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_15 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { style: {"max-width":"150px"} }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { style: {"max-width":"150px"} }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["onClick", "disabled"]
const _hoisted_36 = ["onClick", "disabled"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]

import { ref, onMounted, watch, inject } from "vue";
import AccountTradeStat from "@/projects/tenant/modules/accounts/components/accountTradeStat/AccountTradeStat.vue";
import TradeServices from "../services/TradeServices";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Field, ErrorMessage, useForm } from "vee-validate";
import BriefDetailModal from "../modals/BriefDetailModal.vue";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";

enum TabStatus {
  search = 1,
  record = 2,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BriefDetail',
  setup(__props) {

const openConfirmBox = inject(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);

const BriefDetailRef = ref<InstanceType<typeof BriefDetailModal>>();
const today = new Date();

const isLoading = ref(false);
const tab = ref(TabStatus.record);
const records = ref([]);
const editRow = ref(-1);
const addNewRecord = ref(false);

const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const period = ref([
  formatDate(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
  ),
  formatDate(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
  ),
]);

const handleDateChange = () => {
  // Ensure that period.value[1] is set to 23:59:59
  const endDate = new Date(period.value[1]);
  endDate.setHours(23, 59, 59, 999);
  period.value[1] = formatDate(endDate);
};

const fetchData = async () => {
  try {
    isLoading.value = true;
    records.value = await TradeServices.queryBriefDetailList(
      "Public",
      0,
      "BriefDetailLists"
    );
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const updateListInfo = async () => {
  console.log(records.value.value);
  addNewRecord.value = false;

  isLoading.value = true;

  try {
    await TradeServices.updateBriefDetailList(
      "Public",
      0,
      "BriefDetailLists",
      records.value
    );
    MsgPrompt.success("Update successfully").then(() => {
      editRow.value = -1;
    });
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    fetchData();
  }
};

const showWithdrawInfo = async (_item: any) => {
  BriefDetailRef.value?.show(_item, period.value);
};

const addRecord = async () => {
  addNewRecord.value = true;
  const newItem = {
    name: "",
    mt4: "",
    mt5: "",
  };
  records.value.value.push(newItem);
  editRow.value = records.value.value.length - 1;
};

const deleteRecord = async (_index: any) => {
  records.value.value.splice(_index, 1);
  updateListInfo();
};

const openConfirmPanel = (_index: any, _item: any) => {
  openConfirmBox?.(() => deleteRecord(_index), void 0, {
    confirmTitle: "Delete Record",
    confirmText: "Confirm to delete this record - " + _item.name,
  });
};

watch(
  () => period.value,
  () => {
    handleDateChange();
  }
);

onMounted(async () => {
  await fetchData();
  handleDateChange();
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("a", {
            class: _normalizeClass([
            'nav-link text-active-primary pb-4',
            { active: tab.value === TabStatus.record },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = TabStatus.record))
          }, "Record", 2)
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass([
            'nav-link text-active-primary pb-4',
            { active: tab.value === TabStatus.search },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = TabStatus.search))
          }, "Search", 2)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (tab.value === TabStatus.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(AccountTradeStat, {
                accountId: null,
                fromBrirfDetail: true
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (tab.value === TabStatus.record)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _createVNode(_component_el_date_picker, {
                    modelValue: period.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((period).value = $event)),
                    type: "datetimerange",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                    "range-separator": "-",
                    "value-format": "YYYY-MM-DD HH:mm:ss",
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_el_button, {
                    type: "success",
                    plain: "",
                    onClick: addRecord,
                    loading: isLoading.value,
                    class: "ms-9",
                    disabled: addNewRecord.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.add")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_15, [
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.id")), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("fields.name")), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("tip.mt4")), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t("tip.mt5")), 1),
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("action.detail")), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("action.action")), 1)
                  ])
                ]),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
                      _createVNode(_component_LoadingRing)
                    ]))
                  : (!isLoading.value && records.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                        _createVNode(_component_NoDataBox)
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_25, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", _hoisted_26, [
                              (editRow.value == index)
                                ? (_openBlock(), _createBlock(_unref(Field), {
                                    key: 0,
                                    class: "form-control form-control-solid",
                                    name: "name",
                                    modelValue: item.name,
                                    "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(item.name), 1))
                            ]),
                            _createElementVNode("td", _hoisted_28, [
                              (editRow.value == index)
                                ? (_openBlock(), _createBlock(_unref(Field), {
                                    key: 0,
                                    class: "form-control form-control-solid",
                                    name: "mt4",
                                    modelValue: item.mt4,
                                    "onUpdate:modelValue": ($event: any) => ((item.mt4) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.mt4), 1))
                            ]),
                            _createElementVNode("td", _hoisted_30, [
                              (editRow.value == index)
                                ? (_openBlock(), _createBlock(_unref(Field), {
                                    key: 0,
                                    class: "form-control form-control-solid",
                                    name: "mt5",
                                    modelValue: item.mt5,
                                    "onUpdate:modelValue": ($event: any) => ((item.mt5) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.mt5), 1))
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createVNode(_component_el_button, {
                                class: "",
                                onClick: ($event: any) => (showWithdrawInfo(item))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.viewDetails")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _createElementVNode("td", _hoisted_33, [
                              (editRow.value == index)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    href: "#",
                                    class: "btn btn-light btn-success btn-sm ms-5",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (updateListInfo())),
                                    disabled: isLoading.value
                                  }, _toDisplayString(_ctx.$t("action.save")), 9, _hoisted_34))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    href: "#",
                                    class: "btn btn-light btn-primary btn-sm ms-5",
                                    onClick: ($event: any) => (editRow.value = index),
                                    disabled: isLoading.value
                                  }, _toDisplayString(_ctx.$t("action.edit")), 9, _hoisted_35)),
                              _createElementVNode("button", {
                                href: "#",
                                class: "btn btn-light btn-danger btn-sm ms-5",
                                onClick: ($event: any) => (openConfirmPanel(index, item)),
                                disabled: isLoading.value
                              }, _hoisted_38, 8, _hoisted_36)
                            ])
                          ]))
                        }), 128))
                      ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(BriefDetailModal, {
        ref_key: "BriefDetailRef",
        ref: BriefDetailRef
      }, null, 512)
    ])
  ], 64))
}
}

})